import { defineMessages } from "react-intl";

export const customerStatsMessages = defineMessages({
  totalCustomers: {
    id: 'V91gfy',
    defaultMessage: "Total Customers",
  },
});
